<ng-container *ngIf="feeder">
  <!-- RESPUESTAS PARA EL SERVER -->
  <div class="border_alert">
    <div class="view_alert">
      <div class="item">
        <div class="p-2">
          <p class="m-0 ml-2 font-weight-bold mr-2">{{ "feed-component.ration-shipment" | translate }}</p>
        </div>
      </div>
      <div class="d-flex">
        <div
          class="item mr-2 c-pointer"
          *ngIf="feeder.status_refeed.server !== 'error'"
          (click)="frameMonitor(feeder)"
        >
          <div class="border-success d-flex align-items-center">
            <div
              class="w-100 d-flex justify-content-between align-items-center p-2"
              [ngStyle]="{'background-color': '#B6D7A8'}"
            >
              <p class="m-0 ml-2 font-weight-bold mr-2">{{ "view-alert.feeder-status" | translate }}</p>

              <i
                *ngIf="classChecks(feeder, 'server'); else loading"
                class="fa mr-1"
                aria-hidden="true"
                [class]="classChecks(feeder, 'server') + ' ' + classIcon(feeder, 'server')"
              ></i>
            </div>
          </div>
        </div>
        <div class="item" *ngIf="feeder.status_refeed.server !== 'error' && mode_test">
          <div class="d-flex align-items-center">
            <div
              class="bg-alert w-100 d-flex justify-content-between align-items-center p-2"
              [class]="feeder.status_refeed.ration_status === 'error' ? 'danger' : 'success' "
            >
              <p class="m-0 ml-2 font-weight-bold mr-2">{{ "view-alert.ration-received" | translate }}</p>
              <i
                *ngIf="classChecks(feeder, 'ration_status'); else loading"
                class="fa mr-1"
                aria-hidden="true"
                [class]="classChecks(feeder, 'ration_status') + ' ' + classIcon(feeder, 'ration_status')"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <div class="item" *ngIf="feeder.status_refeed.server === 'error'">
        <div class="text-center">
          <p class="m-0 ml-2 font-weight-bold mr-2">{{ "view-alert.request-error" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="w-50" *ngFor="let section of sections">
        <div class="border center p-1 p-1" [class]="classBorder(feeder, section)">
          <i
            *ngIf="classChecks(feeder, section); else loading"
            class="fa mr-1"
            aria-hidden="true"
            [class]="classChecks(feeder, section) + ' ' + classIcon(feeder, section)"
          ></i>

          <small>{{ label(section) }}</small>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="spinner-border spinner-border-sm mr-1" role="status">
    <span class="sr-only"></span>
  </div>
</ng-template>
